__webpack_require__.p = "/reports-api-adjustments/referrals-hub/";